import { gsap } from "gsap";
import { isAuthor, isMobile } from "../../../js/utils";
import { animateObserver, animateWords, parallaxHeroHome, showHeroHome } from "../../../js/animations/animations";

(() => {
  const BRHHeroRestaurant = () => {
    const selectors = {
      component: "brh-hero-restaurant",
    };

    const init = () => {
      //== Animations
      if (!isMobile() && !isAuthor()) {
        const heroes = document.querySelectorAll(`.${selectors.component}`);
        if (heroes.length > 0) {
          heroes?.forEach((element) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: element,
                toggleActions: "restart reverse none none",
                start: "30% top",
                end: "bottom top",
                scrub: true,
              },
            });
            const imagesParallax = element.querySelectorAll(".cmp-image");
            imagesParallax.length > 0 && timeline.add(parallaxHeroHome({ classElement: imagesParallax, trigger: ".js-hero-home-parallax-trigger" }), 0);
            const videosParallax = element.querySelectorAll(".brh-video__player");
            videosParallax.length > 0 && timeline.add(parallaxHeroHome({ classElement: videosParallax, trigger: ".js-hero-home-parallax-trigger" }), 0);

            const appearances = gsap.timeline();
            const images = element.querySelectorAll(".cmp-image__image");
            images.length > 0 && appearances.add(showHeroHome(images), 0);
            const videos = element.querySelectorAll(".brh-video__player");
            videos.length > 0 && appearances.add(showHeroHome(videos), 0);

            const titles = element.querySelectorAll(".brh-hero-restaurant__title");
            titles.length > 0 && appearances.add(animateWords({ classElement: titles }), 0);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHHeroRestaurant);
})();
